import { gql } from '@apollo/client';

const GET_ORG_INFO = gql`
  query GetOrgInfo($id: Int!) {
    mddapOrganization(id: $id) {
      Name
      SystemName
    }
  }
`;

export default GET_ORG_INFO;
